import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-statistic-widget',
  templateUrl: './statistic-widget.component.html',
  styleUrls: ['./statistic-widget.component.scss']
})
export class StatisticWidgetComponent implements OnInit {

  @Input() label:String = '';
  @Input() value:String = '';

  constructor() { }

  ngOnInit(): void {
  }

}
